import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import VueJsonLD from 'vue-jsonld'

Vue.use(VueJsonLD)
 
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.config.productionTip = false
axios.defaults.withCredentials = false;


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if(to.meta.requireAuth && router.app.$cookies.isKey('member')){
      next()
  }
   else{
    next()
  }
})
